// import Vue from "vue";
// import Vuex from "vuex";
// import rootModule from "./rootModule";

// Vue.use(Vuex);

// const files = require.context("./modules", false, /.js$/);

// files.keys().forEach(key => {
//   const store = files(key).default;
//   const moduleName = key.replace(/^\.\//, "").replace(/\.js$/, "");
//   let modules = rootModule.modules || {};
//   modules[moduleName] = store;
//   modules[moduleName].namespaced = true; // 预防忘记添加命名空间
// });
// const store = new Vuex.Store(rootModule);console.log(store)

// export default store;


import Vue from "vue";
import Vuex from "vuex";
import user from "./modules/user";
Vue.use(Vuex);
export default new Vuex.Store({
    modules: {
        user
    }
})